__turbopack_context__.v({
  "arrow": "hotspot-module-scss-module__4pHNua__arrow",
  "arrowContainer": "hotspot-module-scss-module__4pHNua__arrowContainer",
  "citation": "hotspot-module-scss-module__4pHNua__citation",
  "content": "hotspot-module-scss-module__4pHNua__content",
  "hotspotButton": "hotspot-module-scss-module__4pHNua__hotspotButton",
  "innerRingPulse": "hotspot-module-scss-module__4pHNua__innerRingPulse",
  "outerRingPulse": "hotspot-module-scss-module__4pHNua__outerRingPulse",
  "popoverContainer": "hotspot-module-scss-module__4pHNua__popoverContainer",
});
